import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppModeService {

  public getAppModeValue<T>(bwmValue: T, liberroValue: T, fallback?: T): T | null {
    if (environment.appBuildMode === 'bwm') return bwmValue;
    if (environment.appBuildMode === 'liberro') return liberroValue;
    return fallback ?? null;
  }

  public isBwm(): boolean {
    return environment.appBuildMode === 'bwm';
  }

  public isLiberro(): boolean {
    return environment.appBuildMode === 'liberro';
  }

}